import { useState, useEffect, useRef } from 'react';

const useEqualHeight = (name) => {
	const ref = useRef(null);
	const [maxHeight, setMaxHeight] = useState(0);

	useEffect(() => {
		const updateHeight = () => {
			if (typeof window === "undefined") return;
			// Using requestAnimationFrame prevents excessive updates.
			requestAnimationFrame(() => {
				const elements = document.querySelectorAll(`[data-equal-height="${name}"]`);
				if (!elements.length) return;
				elements.forEach(el => (el.style.minHeight = ''));

				const heights = Array.from(elements).map(el => el.getBoundingClientRect().height);
				const newMaxHeight = Math.max(...heights);

				setMaxHeight(newMaxHeight);
				elements.forEach(el => (el.style.minHeight = `${newMaxHeight}px`));
			});
		};

		window.addEventListener('resize', updateHeight);
		updateHeight();

		return () => {
			window.removeEventListener('resize', updateHeight);
			const elements = document.querySelectorAll(`[data-equal-height="${name}"]`);
			elements.forEach(el => (el.style.minHeight = ''));
		};
	}, [name]);


	return [ref, maxHeight];
};

export default useEqualHeight;